import { dispatch } from "store/store";

import { budgetBuilder as constants } from "../../constants";
import { actionLoaderFactory } from "../../factories/fetchable";


export const budgetFactory = actionLoaderFactory(constants, constants.BUDGET);

export const updatePeriodData = (data, isCostShare) => {
	const key = isCostShare ? "costShare" : "sponsorCosts";

	dispatch({
		type: constants.UPDATE_PERIOD,
		payload: { [key]: data },
	});
};

export const updateResearchTeam = (members, unnamed) => dispatch({
	type: constants.UPDATE_RESEARCH_TEAM,
	payload: {
		members,
		unnamed,
	},
});

export const updateResearchTeamMembers = members => dispatch({
	type: constants.UPDATE_RESEARCH_TEAM,
	payload: {
		members,
	},
});

export const updateInternalCostShareLineItems = internalCostShare => dispatch({
	type: constants.UPDATE_LINE_ITEMS,
	payload: {
		internalCostShare,
	},
});

export const updateExternalCostShareLineItems = externalCostShare => dispatch({
	type: constants.UPDATE_LINE_ITEMS,
	payload: {
		externalCostShare,
	},
});

export const updateSponsoredCostsLineItems = sponsoredCosts => dispatch({
	type: constants.UPDATE_LINE_ITEMS,
	payload: {
		sponsoredCosts,
	},
});

export const setCurrentVersion = version => dispatch({
	type: constants.SET_CURRENT_VERSION,
	payload: version,
});
